import { Component } from '@angular/core';

@Component({
  selector: 'app-instafeed',
  imports: [],
  templateUrl: './instafeed.component.html',
  styleUrl: './instafeed.component.scss'
})
export class InstafeedComponent {

}
